import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcComponentsService, DetailBcLineinfos } from '../../bc-components.service';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { getDestByString, NTHDestination, getStringByDest } from 'src/app/shared/constants/flag';
import { SsFamilleModel } from 'src/app/shared/models/simple-types/ss-famille.model';
import { CategorieModel } from 'src/app/shared/models/simple-types/categorie.model';
import { Ca2Service } from 'src/app/shared/services/societe-linked/ca2.service';
import { CompService } from 'src/app/shared/services/societe-linked/comp.service';
import { NaService } from 'src/app/shared/services/simple/na.service';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { CategorieService } from 'src/app/shared/services/simple/categorie.service';
import { Ca1Service } from 'src/app/shared/services/societe-linked/ca1.service';

export interface DialogData {
  referentiel: Observable<DetailBcLineinfos>;
  bcLineForm: UntypedFormGroup;
  i: number;
  titre: string;
  dBc: Date;
  soc: SocieteModel;
  lineBCEnv: UntypedFormGroup;
}

@Component({
  selector: 'app-modal-bc-env-line-info',
  templateUrl: './modal-bc-env-line-info.component.html',
  styleUrls: ['./modal-bc-env-line-info.component.scss'],
})

export class ModalBcLineEnvInfoComponent implements OnInit, AfterViewChecked {

  referentiel: DetailBcLineinfos = new DetailBcLineinfos();
  minDateLiv: string = moment(new Date()).format('YYYY-MM-DD');
  bcLineForm: UntypedFormGroup;
  //public destinations = ["Commerce", "Exploitation", "Frais Généraux"];
  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              private readonly changeDetectorRef: ChangeDetectorRef,
              public router: Router,
              public dialogRef: MatDialogRef<Component>,
              private bcComposantService: BcComponentsService,
              private ca2Service: Ca2Service,
              private compService: CompService,
              private naService: NaService,
              private categorieService: CategorieService,
              protected ca1Service: Ca1Service,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) {
  }

  ngOnInit(): void {
    this.bcLineForm = this.data.bcLineForm;
    this.minDateLiv = moment(this.data.dBc).format('YYYY-MM-DD');
    this.ca2Service.getFromNaCa1(this.bcLineForm.controls.idSociete.value,  this.bcLineForm.controls.codeNa.value, this.bcLineForm.controls.codeCa1.value, 'BC').subscribe(ca2s => {
      if (ca2s) {
        this.referentiel.ca2s = ca2s;
        this.bcLineForm.get('codeCa2').addValidators(Validators.required);
        this.categorieService.GetFromCodeSociete(this.bcLineForm.get('codeCategorie').value, this.bcLineForm.controls.idSociete.value).subscribe(cat => {
          if (cat) {
            this.ca1Service.getFromCodeAndSociete(this.bcLineForm.controls.codeCa1.value, this.bcLineForm.controls.idSociete.value).subscribe(ca1 => {
              if (ca1) {
                this.naService.getFromDestinationCategorie(this.data.soc.idActivite, cat.id, this.bcLineForm.controls.destination.value).subscribe(na => {
                  if (na) {
                    this.compService.getFromNaAndSociete(this.bcLineForm.controls.idSociete.value, na.id).subscribe(comps => {
                      if (comps) {
                        this.referentiel.comps = comps;
                        this.bcLineForm.get('codeComp').addValidators(Validators.required);
                      } else {
                        this.bcLineForm.get('codeComp').disable();
                      }
                    });
                  }
                });
              }
            });
          }
        }); 
      } else {
        this.bcLineForm.get('codeCa2').disable();
      }
    });       
  }

  getString(dest: NTHDestination): string{
    return getStringByDest(dest);
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    this.bcLineForm.get('qte').patchValue(this.bcLineForm.get('ht').value);
    this.bcLineForm.get('pu').patchValue(1);
    this.bcLineForm.get('qteLivre').patchValue(this.bcLineForm.get('ht').value);
    this.bcLineForm.get('qteRestant').patchValue(0);
    (this.bcLineForm.get('livraisonsBc') as UntypedFormArray).controls[0].get('dLivraison').patchValue(this.bcLineForm.get('dLivraison').value);
    if (this.bcLineForm.valid) {
      if (this.bcLineForm.controls.ht.value > this.data.lineBCEnv.controls.htRestant.value) {
        this.toastr.warning("Le montant renseigné est supérieur au montant budgétisé restant");
      } else if (this.data.i === 1 && this.bcLineForm.controls.ht.value === this.data.lineBCEnv.controls.ht.value) {
        this.toastr.warning("Impossible de livrer en une seule fois");
      } else {
        this.dialogRef.close(this.bcLineForm);
      }
    }
    if (!this.bcLineForm.controls.codeCa2.valid) {
      this.bcComposantService.loadCa2(this.data.i, this.bcLineForm.controls.codeCa1.value, this.bcLineForm.controls.codeNa.value);
    }
    if (!this.bcLineForm.controls.codeComp.valid) {
      this.bcComposantService.loadComp(this.data.i, this.bcLineForm.controls.codeNa.value,
      this.bcLineForm.controls.libelleNa.value);
    }
    this.displayErrors();
  }

  displayErrors(): void {
    for (const bcline in this.bcLineForm.controls) {
      if (bcline) {
        this.bcLineForm.controls[bcline].markAsTouched();
      }
    }
  }
}
